import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import { MxValidationService } from 'src/app/core/services';

@Component({
 standalone: false,
  selector: 'mx-form-control-messages',
  templateUrl: './mx.form-control-messages.component.html',
  styleUrls: ['./mx.form-control-messages.component.scss'],
})

export class MxFormControlMessagesComponent  extends MxBaseComponent {
  @Input() control: AbstractControl;
  @Input() style: string;
  constructor(private i18NextPipe: I18NextPipe) {
    super();
  }

  get errorMessage() {
    for (let propertyName in this.control.errors) {
      if (
        this.control.errors.hasOwnProperty(propertyName) &&
        this.control.touched &&
        this.control.invalid &&
        this.control.dirty
      ) {
        const error = MxValidationService.getValidatorError(
          propertyName,
          this.control.errors[propertyName]
        );

        return error.params
          ? this.i18NextPipe.transform(
              `validation:${error.message}`,
              error.params[0]
            )
          : this.i18NextPipe.transform(`validation:${error.message}`);
      }
    }
    return null;
  }
}

